import { render, staticRenderFns } from "./NavbarAfterLogin-v2.vue?vue&type=template&id=fa80ecf8&scoped=true&lang=pug"
import script from "./NavbarAfterLogin-v2.vue?vue&type=script&lang=js"
export * from "./NavbarAfterLogin-v2.vue?vue&type=script&lang=js"
import style0 from "./NavbarAfterLogin-v2.vue?vue&type=style&index=0&id=fa80ecf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa80ecf8",
  null
  
)

export default component.exports